import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const ProductosView = lazy(() => import('../../container/administracion/productos/Index'));
const ProductosForm = lazy(() => import('../../container/administracion/productos/Form'));

const ProductosRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/productos/listado`} component={ProductosView} />      
      <Route path={`${path}/productos/agregar`} component={ProductosForm} />
      <Route exact path={`${path}/productos/editar/:id`} component={ProductosForm} />  
    </Switch>
  );
};

export default ProductosRoute;

